import React from 'react';

import { connect } from 'react-redux';

import FullLoan from './FullLoan';
import { SAVE_EDITED_LOAN_APPLICATION } from './LoanRequestDetails.actions';

class LoanRequestDetails extends React.Component {
    UNSAFE_componentWillUpdate() {
        this.props.unregisterHideCallback();
    }

    render() {
        const {
            handleHideCallback,
            closeModal,
            saveEditedLoanApplication,
            ...requestedLoanProps
        } = this.props;

        return (
            <FullLoan
                saveStateChanges={saveEditedLoanApplication}
                handleHideCallback={handleHideCallback}
                closeModal={closeModal}
                {...requestedLoanProps}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    saveEditedLoanApplication: () =>
        dispatch({
            type: SAVE_EDITED_LOAN_APPLICATION
        })
});

export default connect(null, mapDispatchToProps)(LoanRequestDetails);
